import { Component, Input } from '@angular/core';
import { BadgeProps, badgeStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-badge',
  template: `
    <span [ngClass]="badge">
      <kite-icon *ngIf="icon" [name]="icon" size="sm"></kite-icon>
      <span *ngIf="label && size !== 'sm'">{{ label }}</span>
    </span>
  `,
})
export class BadgeComponent {
  /**
   * Tamaño del badge: ms, md o lg
   */
  @Input() size: BadgeProps['size'];

  /**
   * Variante del badge. Determina su color
   */
  @Input() variant: BadgeProps['variant'];

  /**
   * ícono del badge}
   */
  @Input() icon: BadgeProps['icon'];

  /**
   * Posición del badge respecto de su elemento contenedor
   */
  @Input() position: BadgeProps['position'];

  /**
   * Texto del badge
   */
  @Input() label: BadgeProps['label'];

  /**
   * CSS del componente
   */
  @Input() css: BadgeProps['css'];

  public get badge(): string[] {
    return [
      badgeStyles({
        variant: this.variant,
        size: this.size,
        onlyIcon: !!((this.icon && !this.label) || (this.size === 'sm' && this.icon)),
        position: this.position,
        positioned: !!this.position,
        css: this.css,
      }).className,
    ];
  }
}
